import { render, staticRenderFns } from "./IncludeUrl.vue?vue&type=template&id=87410e54&scoped=true"
import script from "./IncludeUrl.vue?vue&type=script&lang=js"
export * from "./IncludeUrl.vue?vue&type=script&lang=js"
import style0 from "./IncludeUrl.vue?vue&type=style&index=0&id=87410e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87410e54",
  null
  
)

export default component.exports